import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_SUNRISE = defineFcm('starter_experience_dashboard_sunrise')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_dashboard_sunrise_v1',
		enabled: false,
	})
	// Enable only if both country + locale are enabled, or if global is enabled.
	// Other properties come from the country value e.g. experimentName.
	.withMerger(({ countryValue, localeValue, globalValue }) => {
		return {
			...countryValue,
			enabled: (countryValue.enabled && localeValue.enabled) || globalValue.enabled,
		};
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description: 'Controls the visibility of the Sunrise Starter Experience Dashboard',
		mergeLogic:
			'Enabled when both country and locale are enabled, or when global is enabled; non-boolean properties from country',
		import: false,
		template: {
			experimentName: 'starter_experience_dashboard_sunrise_v1',
			enabled: false,
		},
	});
